import { LocalStorageService } from 'angular-2-local-storage';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ExternalViewService } from '../../services/external-view/external-view.service';

@Component({
  selector: 'app-external-view',
  templateUrl: './external-view.component.html',
  styleUrls: ['./external-view.component.css'],
  providers: [ExternalViewService]
})

export class ExternalViewComponent implements OnInit {
  public url: SafeResourceUrl;
  private storageUserData: any = null;

  constructor(
    private route: ActivatedRoute,
    private externalViewService: ExternalViewService,
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer) {}

  ngOnInit() {

    if(sessionStorage.getItem('userData')){
      this.storageUserData = JSON.parse(sessionStorage.getItem('userData'));
    }
    else if(this.localStorageService.get('userData')){
      this.storageUserData = this.localStorageService.get('userData');
    }    
    
    this.route.params.subscribe(params => {
      this.externalViewService.getViewUrl(params['origin'], params['idapplication'], params['idmenu']).subscribe(
        res => {
          this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
            res[0].link.toString()
            .replace('$access_token$', this.storageUserData.token)
            .replace('$companyId$', this.storageUserData.selectedCompany)
            .replace('$language$', this.storageUserData.language)
          )
        }
      )
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/views/external-view/external-view.component.ts